export const COMPONENT_NAME = 'Checkbox';

export const CHECKBOX_COMMANDS = {
	CREATE: COMPONENT_NAME + 'Create',
	GET_CHECKED: COMPONENT_NAME + 'GetChecked',
	CHANGE: COMPONENT_NAME + 'Change',
	GET_CONTENT: COMPONENT_NAME + 'GetContent',
	DIFF: COMPONENT_NAME + 'Diff',
	ENABLED: COMPONENT_NAME + 'Enabled',
	DIFF_BULK: COMPONENT_NAME + 'DiffBulk'
};

export const CHECKBOX_ATTR_ID = 'id';
export const CHECKBOX_ATTR_CHECKED = 'checked';
export const COMPONENT_ATTR_NEW_VALUE = COMPONENT_NAME + 'NewValue';
export const COMPONENT_ATTR_CAN_REVIEW = COMPONENT_NAME + 'CanReview';
export const CHECKBOX_ATTR_ENABLED = 'data-enabled';

export const CHECKBOX_OUT_COMMANDS = {
	CREATE: `${ COMPONENT_NAME }.create`,
	GET_CHECKED: `${ COMPONENT_NAME }.getChecked`,
	CHANGE: `${ COMPONENT_NAME }.change.checked`,
	DIFF: `${ COMPONENT_NAME }.diff`,
	DIFF_REVIEW: `${ COMPONENT_NAME }.diffReview`,
	DIFF_BULK: `${ COMPONENT_NAME }.diffBulk`,
	ENABLED: `${ COMPONENT_NAME }.enabled`
};
